import {
    AfterViewInit,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { IInsertMediaUploadItem } from '@fi-shared/fi-insert-media/fi-insert-media';
import { Observable, Subject } from 'rxjs';
import { SideListOptionType } from '@fi-shared/types';
import { FiMediaStorageService } from '@fi-shared/media-bank/fi-media-storage.service';
import { FiMediaBankService } from '@fi-shared/media-bank';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { AppTextService } from '@fi-shared/app-text';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-insert-media-details',
    templateUrl: './fi-insert-media-details.component.html',
    styleUrls: ['./fi-insert-media-details.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-insert-media-details' },
    standalone: false,
})
export class FiInsertMediaDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() uploadStarted$ = new Observable<IInsertMediaUploadItem>();
    @Input() uploadCancelled$ = new Observable<IInsertMediaUploadItem>();
    @Input() uploadFinished$ = new Observable<IInsertMediaUploadItem>();
    @Input() multiple: boolean;
    @Input() allowStoreInMyFiles: boolean;
    @Input() allowedFileTypes: number[];
    @Input() isTableDisplayType: boolean;
    @Output() selectedUploadItemsChange = new EventEmitter<IInsertMediaUploadItem[]>();
    @Output() onInsertMediaDisplayTypeChange = new EventEmitter<number>();

    private selectedOldMediaUploadItems: IInsertMediaUploadItem[] = [];
    private selectedNewMediaUploadItems: IInsertMediaUploadItem[] = [];

    SideListOptionType = SideListOptionType;
    isMobilePhone: boolean;
    hideFilters: boolean;

    filterTypes: number[] = [];
    filterTypePeriods: number[] = [];
    selectedTagIds: number[] = [];

    isFilterShown: boolean = false;
    reloadData$ = new Subject<void>();

    constructor(
        private mediaStorageService: FiMediaStorageService,
        private appTextService: AppTextService,
        private fiMediaBankService: FiMediaBankService,
        private fiBackend: FiBackendService,
        private customerDataService: FiCustomerDataService,
        private cdr: ChangeDetectorRef,
        private loadingService: LoadingService,
        private detectDeviceService: DetectDevicesService,
    ) {}

    ngOnInit(): void {
        this.isMobilePhone = this.hideFilters = this.detectDeviceService.isMobilePhone();
    }

    ngAfterViewInit(): void {
        this.reloadData$.next();
    }

    setInsertMediaDisplayType(newDisplayType: number) {
        this.onInsertMediaDisplayTypeChange.emit(newDisplayType);
    }

    onSelectedOptionsMainChanged($event: number[]) {
        this.filterTypes = $event;
        this.reloadData$.next();
    }

    onSelectedOptionsPeriodChanged($event: number[]) {
        this.filterTypePeriods = $event;
        this.reloadData$.next();
    }

    onSelectedOptionsTagsChanged($event: number[]) {
        this.selectedTagIds = $event;
        this.reloadData$.next();
    }

    clearFilters() {
        this.filterTypes = [];
        this.filterTypePeriods = [];
        this.selectedTagIds = [];
        setTimeout(() => this.reloadData$.next());
    }

    selectedOldUploadsChange(selectedUploadItems: IInsertMediaUploadItem[]) {
        this.selectedOldMediaUploadItems = selectedUploadItems;
        this.onSelectedUploadItemsChange();
    }

    selectedNewUploadsChange(selectedNewUploadItems: IInsertMediaUploadItem[]) {
        this.selectedNewMediaUploadItems = selectedNewUploadItems;
        this.onSelectedUploadItemsChange();
    }

    private onSelectedUploadItemsChange() {
        this.selectedUploadItemsChange.emit([...this.selectedOldMediaUploadItems, ...this.selectedNewMediaUploadItems]);
    }

    toggleFilterVisibility() {
        this.isFilterShown = !this.isFilterShown;
    }

    isFilterIconActive(): boolean {
        return (
            this.isFilterShown ||
            !!this.filterTypes?.length ||
            !!this.filterTypePeriods?.length ||
            !!this.selectedTagIds?.length
        );
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
